export const ATTENDANCE_STATUS = {
    ANWESEND: 'anwesend',
    VERSPAETET: 'verspaetet',
    FEHLT: 'fehlt',
    EXCUSED_PRAXISMODUL: 'excused_praxismodul',
};
export const ATTENDANCE_STATUS_VALUES = Object.values(ATTENDANCE_STATUS);
export const SCAN_SOURCES = {
    KIOSK: 'kiosk',
    KIOSK_LOGOUT: 'kiosk_logout',
    TEACHER: 'teacher',
    TEACHER_LOGOUT: 'teacher_logout',
    AUTO_LOGOUT: 'auto_logout',
};
export const SCAN_SOURCE_VALUES = Object.values(SCAN_SOURCES);
export const LOGOUT_SOURCES = [
    SCAN_SOURCES.KIOSK_LOGOUT,
    SCAN_SOURCES.TEACHER_LOGOUT,
    SCAN_SOURCES.AUTO_LOGOUT,
];
export const ACTIVE_LOGOUT_SOURCES = [
    SCAN_SOURCES.KIOSK_LOGOUT,
    SCAN_SOURCES.TEACHER_LOGOUT,
];
export const CHECKIN_SOURCES = [
    SCAN_SOURCES.KIOSK,
    SCAN_SOURCES.TEACHER,
];
export const SCAN_COOLDOWN_SECONDS = 10;
// Praxismodul scaffolding (CLAUDE.md ADR praxismodul-and-auto-logout.md,
// Prompt 17). The MIN/MAX bounds are referenced by both shared Zod schemas
// and the admin routes' input validation.
export const SCHOOL_HOUR_BOUNDS = { MIN: 1, MAX: 9 };
export const DAY_OF_WEEK_BOUNDS = { MIN: 1, MAX: 7 };
export const PRAXISMODUL_RETURN_GRACE_BOUNDS = { MIN: 0, MAX: 60 };
// Auto-logout delay + flag-detection thresholds (Prompt 21, ADR
// praxismodul-and-auto-logout.md §Feature 2). Auto-logout fires at
// pdEnd + autoLogoutDelayMinutes; flag detection runs at pdEnd +
// flagAfterMinutes. Cross-field invariant: flagAfter < autoLogoutDelay
// (strict — equality races the synthetic logout sweep).
export const AUTO_LOGOUT_DELAY_BOUNDS = { MIN: 0, MAX: 120 };
export const FLAG_AFTER_BOUNDS = { MIN: 0, MAX: 60 };
export function isLogoutSource(source) {
    return LOGOUT_SOURCES.includes(source);
}
export function isActiveLogoutSource(source) {
    return ACTIVE_LOGOUT_SOURCES.includes(source);
}
export function isCheckinSource(source) {
    return CHECKIN_SOURCES.includes(source);
}
// CLI subcommand topics per CLAUDE.md §27. Top-level dispatcher cases.
export const CLI_TOPICS = {
    STUDENT: 'student',
    TEACHER: 'teacher',
    ROOM: 'room',
    KIOSK: 'kiosk',
    PROJECT_DAY: 'project-day',
    SETTINGS: 'settings',
    AUTO_CHECKOUT: 'auto-checkout',
    // OU-1g.b — Bulk-Import-Kommandos für MA-Zuteilung + Praxismodul.
    ASSIGNMENT: 'assignment',
    PRAXISMODUL: 'praxismodul',
};
// AuditLog targetType values per CLAUDE.md §17. Distinct from SCAN_SOURCES
// even where the string happens to coincide (e.g. 'kiosk', 'teacher').
export const AUDIT_TARGET_TYPES = {
    TEACHER: 'teacher',
    KIOSK: 'kiosk',
    ROOM: 'room',
    STUDENT: 'student',
    PROJECT_DAY: 'project_day',
    SETTINGS: 'settings',
    OFFERING: 'offering',
    // OU-1g.b — Bulk-Import-Ziele.
    ASSIGNMENT: 'assignment',
    PRAXISMODUL: 'praxismodul',
    // OU-1e / #34 — Lehrer-Bewertung (admin-override + delete).
    ASSESSMENT: 'assessment',
};
// /scan auth-context discriminator per CLAUDE.md §13.1. Maps 1:1 to
// SCAN_SOURCES.{KIOSK,TEACHER} for the resulting check-in event but is
// modelled separately so the auth layer doesn't depend on event sources.
export const AUTH_CTX_KINDS = {
    KIOSK: 'kiosk',
    TEACHER: 'teacher',
};
// Frontend smart-redirect decision states per CLAUDE.md §8 (HomeRedirect).
export const HOME_DECISIONS = {
    KIOSK: 'kiosk',
    DASHBOARD: 'dashboard',
    LOGIN: 'login',
    PENDING: 'pending',
};
// Debug-Modus / synthetischer Test-PA (Prompt 25, ADR debug-mode-test-pa.md).
// Admin wählt eine Dauer aus diesem festen Set; Backend rejected krumme Werte.
// Cleanup-Cron purged Test-PA-Daten erst `DEBUG_CLEANUP_DELAY_MINUTES` nach
// `testEndTime`, damit Auto-Logout-Verhalten beobachtbar bleibt.
export const DEBUG_DURATION_MINUTES_OPTIONS = [30, 60, 90, 120, 240];
export const DEBUG_CLEANUP_DELAY_MINUTES = 60;
// OU-Erweiterung (Prompt OU-1a): Angebots-Typen für den PA/MA-Katalog
// (Offering.type). Noch von keinem Code-Pfad genutzt — Vorbereitung für
// OU-2/3, damit dort 'PA'/'MA' nie als Magic-String im Code landen.
export const OFFERING_TYPES = {
    PA: 'PA',
    MA: 'MA',
};
// OU-1g.b: kontextlose Quartals-Kennung für MA-Zuteilungen (Assignment.period).
// Schuljahr + Halbjahr kommen aus Offering.termLabel (Decision #1). Cross-Field-
// Regel + Halbjahr-Ableitung in `assignment-validation.ts`.
export const PERIOD_TYPES = {
    Q1: 'Q1',
    Q2: 'Q2',
    Q3: 'Q3',
    Q4: 'Q4',
};
export const PERIOD_TYPE_VALUES = Object.values(PERIOD_TYPES);
//# sourceMappingURL=constants.js.map